<div id="addButton">
  <button mat-button type="button" (click)="add()">
    <mat-icon>add</mat-icon>
    Create new publication configuration
  </button>
</div>

<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start"  [(selectedIndex)]="selectedIndex">
    @for( item of formArrayControls; track item.value.id ) {
        <mat-tab>
            <ng-template mat-tab-label>
                {{item.value.id}}
                <mat-icon *ngIf="item.invalid" color="warn">error</mat-icon>
              </ng-template>
            <app-publication-configuration [control]="item" (deleteConfigurationEvent)="deleteConfiguration($event)" [parsingFormatGroup]="parsingFormatGroup"></app-publication-configuration>
        </mat-tab>
    }
</mat-tab-group>
